import { connect } from 'react-redux';
import { setFocus } from './focus-observer.actions';
import { FocusObserver } from './focuse-observer.component';

export interface IFocusObserverProps {
    setFocus: (status: boolean) => void;
}

const mapDispatchToProps: IFocusObserverProps = {
    setFocus
};

const Container = connect(null, mapDispatchToProps)(FocusObserver);

export default Container;
